import {
    Component,
    ElementRef,
    Inject,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
    Observable,
    Subscription,
    finalize,
    map,
    startWith,
    takeUntil,
    tap,
} from 'rxjs';
import { initializeEditor } from 'src/app/utils/angular-editor/editorConfig';
import { helper } from 'src/environments/helper';
import { CereriService } from '../cereri.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import {
    ICerereListDT,
    ICerere,
} from '../cereri.interface';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { StorageService } from 'src/app/utils/storage/storage.service';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common.service';
import { DialogService } from 'src/app/utils/services/dialog.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ModalInchidereLucrareComponent } from './modal-inchidere-lucrare/modal-inchidere-lucrare.component';

@Component({
    selector: 'app-cereri-detalii',
    templateUrl: './cereri-detalii.component.html',
    styleUrls: ['./cereri-detalii.component.scss'],
})
export class CereriDetaliiComponent implements OnInit, OnDestroy {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;

    isLoading = false;
    editorConfig!: AngularEditorConfig;
    user: any = null;
    passedCerereId!: number;
    cerere: ICerere | null = null;
    safeHtml!: SafeHtml;
    isCorespondenta: boolean = false;

    // functiiOperator: any[] = [];

    defaultChoiceParameter: { name: string; id: string } = {
        name: '-- Alegeți --',
        id: '-1',
    };

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            cerere: ICerereListDT,
        },
        private dialogRef: MatDialogRef<CereriDetaliiComponent>,
        private cereriService: CereriService,
        private notificationService: NotificationService,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private authService: AuthService,
        private storageService: StorageService,
        private sanitizer: DomSanitizer,
        private commonService: CommonService,
        public toastr: ToastrService,
        public permissionsService: PermissionsService,
    ) {
        this.processUserDetails();
        this.passedCerereId = this.data.cerere.id;
    }

    processUserDetails() {
        var self = this;
        const userObj = self.storageService.getObject(environment.config.userKey);
        userObj
            .then((val) => {
                self.user = val;
            })
            .catch((err) => {
                console.log(err);
            });
    }

    ngOnInit(): void {
        this.getCerereInfo();
        this.editorConfig = initializeEditor();

        // this.commonService.getFunctii().subscribe({
        //     next: (data: any) => {
        //         return (this.functiiOperator = data.data);
        //     },
        //     error: (error) => {
        //         console.error('Error fetching data:', error);
        //     },
        // });
    }

    ngOnDestroy(): void { }

    getCerereInfo() {
        this.isLoading = true;
        this.cereriService
            .getCerere(this.passedCerereId)
            .pipe(map((response: any) => response.data))
            .subscribe({
                next: (cerereData: ICerere) => {
                    this.isLoading = false;
                    this.cerere = cerereData;

                    // if (this.cerere.slug_module === 'corespondenta') {
                    //     this.isCorespondenta = true;
                    // }

                    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(
                        this.cerere.sla
                    );
                },
                error: (error: any) => {
                    this.isLoading = false;
                    console.error('Error', error);
                    let msg;
                    try {
                        msg = error.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService
                        .warningSwal(this.errorTitle, msg, this.errorIcon)
                        .then((result) => {
                            this.closeDialog();
                        });
                }
            });
    }

    onCerereChanged(data: ICerere) {
        this.cerere = data;

        this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(
            this.cerere.sla
        );
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    // Actiuni cerere
    confirmValidareSolicitare() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.validate,
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .validateCerere(this.cerere!.id)
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        let errorMessage = 'Eroare neașteptată.';
                        if (
                            error &&
                            error.error &&
                            error.error.errors &&
                            error.error.errors.message &&
                            error.error.errors.message.length > 0
                        ) {
                            errorMessage = error.error.errors.message[0];
                        }
                        console.log(errorMessage);

                        Swal.showValidationMessage(`${errorMessage}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getCerereInfo();
                });
            }
        });
    }

    confirmInvalidareSolicitare() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.invalidate,
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: 'text', // Enable text input
            inputPlaceholder: this.helper.swalTextConfig.inputPlaceholders.invalidate,
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv de invalidare!';
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .invalidateCerere(this.cerere!.id, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        let errorMessage = 'Eroare neașteptată.';
                        if (
                            error &&
                            error.error &&
                            error.error.errors &&
                            error.error.errors.message &&
                            error.error.errors.message.length > 0
                        ) {
                            errorMessage = error.error.errors.message[0];
                        }
                        console.log(errorMessage);

                        Swal.showValidationMessage(`${errorMessage}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getCerereInfo();
                });
            }
        });
    }

    confirmAnulareSolicitare() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.clasare,
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: 'text', // Enable text input
            inputPlaceholder: this.helper.swalTextConfig.inputPlaceholders.cancel,
            inputValidator: (value) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv..!';
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .anulareCerere(this.cerere!.id, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        let errorMessage = 'Eroare neașteptată.';
                        if (
                            error &&
                            error.error &&
                            error.error.errors &&
                            error.error.errors.message &&
                            error.error.errors.message.length > 0
                        ) {
                            errorMessage = error.error.errors.message[0];
                        }

                        Swal.showValidationMessage(`${errorMessage}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getCerereInfo();
                });
            }
        });
    }

    openInchidereSolicitare(data: ICerere) {
        let dialogRef = this.dialog.open(ModalInchidereLucrareComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getCerereInfo();
            }
        });
    }

    resetValidareCerere() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Sunteți sigur că doriți resetarea validării de cerere?',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: 'Necesită completarea motivului...',
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv';
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    // return 'Este necesar completarea unui motiv!';
                    Swal.showValidationMessage('Este necesar completarea unui motiv!');
                }

                return this.cereriService
                    .resetValidareCerere(this.cerere!.id, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg = '';
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${err}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getCerereInfo();
                });
            }
        });
    }

    resetInvalidareCerere() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Sunteți sigur că doriți resetarea invalidării de cerere?',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: 'Necesită completarea motivului...',
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv';
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    console.log('empty message');
                    // return 'Este necesar completarea unui motiv!';

                    Swal.showValidationMessage('Este necesar completarea unui motiv!');
                }

                return this.cereriService
                    .resetInvalidareCerere(this.cerere!.id, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg = '';
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${err}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getCerereInfo();
                });
            }
        });
    }

    resetAnulareCerere() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Sunteți sigur că doriți resetarea clasării de cerere?',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: 'Necesită completarea motivului...',
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv';
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    console.log('empty message');
                    // return 'Este necesar completarea unui motiv!';
                    Swal.showValidationMessage('Este necesar completarea unui motiv!');
                }

                return this.cereriService
                    .resetClasareCerere(this.cerere!.id, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg = '';
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getCerereInfo();
                });
            }
        });
    }

    resetInchidereCerere() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Sunteți sigur că doriți resetarea închiderii de cerere? Confirmați anularea de închidere cerere în cadrul modulului de INDOC - Registratură?',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text', // Enable text input
            inputPlaceholder: 'Necesită completarea motivului...',
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv';
                }
                return null; // Return null if input is valid
            },
            preConfirm: (inputValue) => {
                if (!inputValue) {
                    console.log('empty message');
                    // return 'Este necesar completarea unui motiv!';
                    Swal.showValidationMessage('Este necesar completarea unui motiv!');
                }

                return this.cereriService
                    .resetInchidereCerere(this.cerere!.id, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg = '';
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        Swal.showValidationMessage(`Request failed: ${err}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getCerereInfo();
                });
            }
        });
    }

    handleButtonClick(actionType: string) {
        switch (actionType) {
            case 'validate':
                this.confirmValidareSolicitare();
                break;
            case 'invalidate':
                this.confirmInvalidareSolicitare();
                break;
            case 'anulare': // clasare
                this.confirmAnulareSolicitare();
                break;
            case 'finalizare':
                this.openInchidereSolicitare(this.cerere!);
                break;
            case 'prezent':
                this.confirmSetPresent();
                break;
            case 'absent':
                this.confirmSetAbsent();
                break;
            case 'cancelSlotQuick':
                this.confirmCancelSlotQuick();
                break;
            default:
                console.log('Unrecognized button value', actionType);
        }
    }

    handleButtonResetClick(actionType: string) {
        switch (actionType) {
            case 'validate':
                this.resetValidareCerere();
                break;
            case 'invalidate':
                this.resetInvalidareCerere();
                break;
            case 'anulare': // clasare
                this.resetAnulareCerere();
                break;
            case 'finalizare':
                this.resetInchidereCerere();
                break;
            case 'prezent':
                this.resetPresent();
                break;
            case 'absent':
                this.resetAbsent();
                break;
            case 'cancelSlotQuick':
                this.resetCancelSlot();
                break;
            default:
                console.log('Unrecognized button value', actionType);
        }
    }

    confirmPreluarePersonala() {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'O să preluați solicitarea curentă. Continuați?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.cereriService
                    .preluarePersonala(this.cerere!.id)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: (res) => {
                            this.isLoading = true;
                            this.notificationService
                                .warningSwal(
                                    this.successTitle,
                                    'Cerere preluată cu succes!',
                                    this.successIcon
                                )
                                .then(() => this.getCerereInfo());
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        },
                    });
            }
        });
    }

    showPreluareNumarRegistratura() {
        return (
            this.cerere?.id_user_assigned !== null &&
            this.cerere?.id_user_assigned == this.user.id_user &&
            this.cerere?.indoc_number == null &&
            this.permissionsService.hasPermission(
                'auth-module.ghiseu.view-ghiseu.generare-numar-registratura'
            )
        );
    }

    confirmPreluareNumarRegistratura() {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Veți prelua un număr de registratură pentru solicitarea curentă. Continuați?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                this.cereriService
                    .preluareNumarRegistratura(this.cerere!.id)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .subscribe({
                        next: (res) => {
                            this.isLoading = true;
                            this.notificationService
                                .warningSwal(
                                    this.successTitle,
                                    'Număr de registratură preluat cu succes!',
                                    this.successIcon
                                )
                                .then(() => this.getCerereInfo());
                        },
                        error: (err) => {
                            let msg;
                            try {
                                msg = err.error.errors.message[0];
                            } catch (error) {
                                msg = helper.dialogConfig.generalMessages.error;
                            }
                            this.notificationService.warningSwal(
                                this.errorTitle,
                                msg,
                                this.errorIcon
                            );
                        },
                    });
            }
        });
    }

    onIsLoadingChange(event: boolean) {
        this.isLoading = event;
    }

    // Prezență - Prezent/Absent
    confirmSetPresent() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Confirmați că cetățeanul este PREZENT la programare?',
            showCancelButton: true,
            confirmButtonColor: '#28a745',
            confirmButtonText: 'Da, Prezent',
            cancelButtonText: this.helper.swalTextConfig.validationMessages.cancelButton,
            input: 'text',
            inputPlaceholder: 'Observații (opțional)',
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .setPresent(this.cerere!.id, { observatii: inputValue || '' })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        let errorMessage = 'Eroare neașteptată.';
                        if (error?.error?.errors?.message?.length > 0) {
                            errorMessage = error.error.errors.message[0];
                        }
                        Swal.showValidationMessage(`${errorMessage}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: 'Cetățean marcat ca prezent cu succes!',
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getCerereInfo();
                });
            }
        });
    }

    confirmSetAbsent() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Confirmați că cetățeanul este ABSENT la programare? Slotul va fi eliberat.',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            confirmButtonText: 'Da, Absent',
            cancelButtonText: this.helper.swalTextConfig.validationMessages.cancelButton,
            input: 'text',
            inputPlaceholder: 'Observații (opțional)',
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .setAbsent(this.cerere!.id, { observatii: inputValue || '' })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        let errorMessage = 'Eroare neașteptată.';
                        if (error?.error?.errors?.message?.length > 0) {
                            errorMessage = error.error.errors.message[0];
                        }
                        Swal.showValidationMessage(`${errorMessage}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: 'Cetățean marcat ca absent. Slotul a fost eliberat.',
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getCerereInfo();
                });
            }
        });
    }

    confirmCancelSlotQuick() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Anulare rapidă slot (ultima secundă). Slotul va fi eliberat imediat.',
            showCancelButton: true,
            confirmButtonColor: '#ffc107',
            confirmButtonText: 'Da, Anulează',
            cancelButtonText: this.helper.swalTextConfig.validationMessages.cancelButton,
            input: 'text',
            inputPlaceholder: 'Motiv (opțional)',
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.cereriService
                    .cancelSlotQuick(this.cerere!.id, { motiv: inputValue || '' })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        let errorMessage = 'Eroare neașteptată.';
                        if (error?.error?.errors?.message?.length > 0) {
                            errorMessage = error.error.errors.message[0];
                        }
                        Swal.showValidationMessage(`${errorMessage}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: 'Slot anulat rapid. Slotul a fost eliberat.',
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getCerereInfo();
                });
            }
        });
    }

    // Reset Prezență
    resetPresent() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Sunteți sigur că doriți resetarea marcării de prezent?',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText: this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text',
            inputPlaceholder: 'Necesită completarea motivului...',
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv';
                }
                return null;
            },
            preConfirm: (inputValue) => {
                return this.cereriService
                    .resetPresent(this.cerere!.id, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg = helper.dialogConfig.generalMessages.error;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) { }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: 'Marcare prezent resetată cu succes!',
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getCerereInfo();
                });
            }
        });
    }

    resetAbsent() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Sunteți sigur că doriți resetarea marcării de absent?',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText: this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text',
            inputPlaceholder: 'Necesită completarea motivului...',
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv';
                }
                return null;
            },
            preConfirm: (inputValue) => {
                return this.cereriService
                    .resetAbsent(this.cerere!.id, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg = helper.dialogConfig.generalMessages.error;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) { }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: 'Marcare absent resetată cu succes!',
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getCerereInfo();
                });
            }
        });
    }

    // Reset prezență - determină automat dacă e prezent sau absent
    resetPresence() {
        if (this.cerere?.presence_status === 1) {
            this.resetPresent();
        } else if (this.cerere?.presence_status === 2) {
            this.resetAbsent();
        }
    }

    resetCancelSlot() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: 'Sunteți sigur că doriți resetarea anulării de slot?',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText: this.helper.swalTextConfig.validationMessages.cancelButton,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            input: 'text',
            inputPlaceholder: 'Necesită completarea motivului...',
            inputValidator: (value: any) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv';
                }
                return null;
            },
            preConfirm: (inputValue) => {
                return this.cereriService
                    .resetCancelSlot(this.cerere!.id, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((err) => {
                        let msg = helper.dialogConfig.generalMessages.error;
                        try {
                            msg = err.error.errors.message[0];
                        } catch (error) { }
                        Swal.showValidationMessage(`Request failed: ${msg}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: 'Anulare slot resetată cu succes!',
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getCerereInfo();
                });
            }
        });
    }
}